export const sku = 'KFCSH';
